module.exports = __webpack_public_path__ + "static/media/icon-hamad.ab1c4432.png";